import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { convertJsonToFormData, mapFormData } from 'helpers/formData';

export interface AdviserReorderPatchOptions {
  position: number;
}

export function adviserReorderApi(path: string) {
  return {
    path,
    PATCH: (params: AdviserReorderPatchOptions) =>
      api.patch<JsonApiResponse>(
        path,
        convertJsonToFormData({
          data: {
            attributes: mapFormData(params),
          },
        })
      ),
  };
}
